import axios from 'axios';

export default {
    get(context, userId) {
        let url = window.apiUrl + '/invoices';
        if (userId) url = url + '?userId=' + userId;
        var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getLink(context, id) {
        
        var options = {
            url: window.apiUrl + '/invoice-link?id=' + id,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    create(context, type) {
        
        var options = {
            url: window.apiUrl + '/invoice/'+type,
            method: 'POST',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    }
}


// WEBPACK FOOTER //
// ./src/services/invoices/index.js